import React from 'react';

function PageHeader({ crumbs = [], title, subtitle, actions, className = '' }) {
  return (
    <div className={`page-header ${className}`}>
      <div>
        {crumbs.length > 0 && (
          <div className="crumbs">
            {crumbs.map((c, i) => (
              <React.Fragment key={c.label + i}>
                {i > 0 && <span> / </span>}
                {c.onClick ? (
                  <a href={`#${c.label}`} onClick={(e) => { e.preventDefault(); c.onClick(); }}>{c.label}</a>
                ) : (
                  <span>{c.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>
        )}
        <div className="page-title">
          {title && <h1>{title}</h1>}
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
}

export default PageHeader;
